interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}

export default function SectionHeader({ title, subtitle, align = 'center' }: SectionHeaderProps) {
  return (
    <div className={align === 'center' ? 'text-center' : ''}>
      <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
      <div className={`mt-4 w-12 h-0.5 bg-primary-500 ${align === 'center' ? 'mx-auto' : ''}`}></div>
    </div>
  );
}